import { ServiceCode, ServiceOrganizationRole } from '@common/enums';

export function getServiceOrganizationRoles(serviceCode: ServiceCode): ServiceOrganizationRole[] {
    switch (serviceCode) {
        case ServiceCode.BariPre:
            return [
                ServiceOrganizationRole.dietetics,
                ServiceOrganizationRole.hospital,
                ServiceOrganizationRole.policlinic,
                ServiceOrganizationRole.psychology,
            ];
        case ServiceCode.BariPost:
            return [
                ServiceOrganizationRole.dietetics,
                ServiceOrganizationRole.hospital,
                ServiceOrganizationRole.lifestyleCoaching,
                ServiceOrganizationRole.policlinic,
                ServiceOrganizationRole.psychology,
            ];
        case ServiceCode.Echography:
        case ServiceCode.HearingLoss:
        case ServiceCode.RespiAller:
        case ServiceCode.OSAS:
            return [ServiceOrganizationRole.policlinic];
        default:
            return [];
    }
}
